import { IStandardNavigationState } from "./standardNavigation.t";

const getters = {
	isStandardMenuOpen(state: IStandardNavigationState) {
		const isMenuOpen = state.isStandardMenuOpen
		return isMenuOpen
	},
	isPreviousMenuStateOpen(state: IStandardNavigationState){
		const isPreviousMenuStateOpen = state.isPreviousMenuStateOpen
		return isPreviousMenuStateOpen;
	}
}

export default getters;